import { SVGProps } from "react";

export const SelectedMapDestinationIcon = (props?: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="29"
      height="33"
      viewBox="0 0 29 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.3065 20.6257C28.3874 18.661 29 16.4181 29 14.0368C29 6.28447 22.5081 0 14.5 0C6.49187 0 0 6.28447 0 14.0368C0 16.5935 0.706111 18.9905 1.93984 21.0551C1.95969 21.0884 1.97967 21.1215 1.99979 21.1545C2.41483 21.8361 2.88767 22.4808 3.41176 23.0822C3.41766 23.089 3.42372 23.0959 3.42963 23.1027C3.43436 23.1081 3.4395 23.114 3.44423 23.1194H3.41176L12.0166 31.9619C13.3635 33.346 15.6365 33.346 16.9834 31.9619L25.5882 23.1194H25.5558C25.5603 23.1142 25.5649 23.109 25.5694 23.1038L25.5708 23.1022C25.6328 23.0313 25.6941 22.9598 25.7547 22.8878C26.2377 22.3129 26.6747 21.7002 27.0602 21.0551C27.1448 20.9135 27.2269 20.7704 27.3065 20.6257ZM14.5042 19.4038C11.6778 19.4038 9.38652 17.1857 9.38652 14.4496C9.38652 11.7135 11.6778 9.49545 14.5042 9.49545C17.3306 9.49545 19.6218 11.7135 19.6218 14.4496C19.6218 17.1857 17.3306 19.4038 14.5042 19.4038Z"
        fill="#1b645b"
      />
    </svg>
  );
};
